import React, { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import api from "../lib/api";

/**
 * Testimonials — reusable section that renders published testimonials from the
 * CMS. Renders nothing when there are none (so no empty/fake section appears).
 */
export const Testimonials = ({ variant = "light", heading = "What clients say", eyebrow = "Testimonials" }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let live = true;
    api.get("/content/testimonials")
      .then(({ data }) => { if (live) setItems(data.testimonials || []); })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  if (!items.length) return null;

  const dark = variant === "dark";
  return (
    <section className={`${dark ? "ek-gradient-dark-soft text-white" : "bg-[#F2F2F3]"} ek-section relative overflow-hidden`} data-testid="testimonials-section">
      <div className="ek-container relative z-10">
        <div className="max-w-3xl">
          <div className={`ek-eyebrow ${dark ? "text-[#A179FA]" : ""}`}>{eyebrow}</div>
          <h2 className={`ek-heading text-3xl md:text-4xl mt-4 ${dark ? "text-white" : "text-black"}`}>{heading}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {items.map((t) => (
            <figure
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className={`${dark ? "bg-black/30 border-white/10" : "bg-white border-zinc-200"} border p-7 lg:p-8 flex flex-col`}
            >
              <Quote size={22} className="text-[#7737F6] mb-4 shrink-0" />
              <blockquote className={`${dark ? "text-zinc-200" : "text-zinc-700"} text-[15px] leading-relaxed font-light flex-1`}>
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6">
                <div className={`text-sm font-semibold ${dark ? "text-white" : "text-black"}`}>{t.name}</div>
                {(t.role || t.company) && (
                  <div className="text-[13px] text-zinc-500">
                    {[t.role, t.company].filter(Boolean).join(" · ")}
                  </div>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
